import {Component, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {UserValidation} from '../../shared/user-validation';
import {CardStoreService} from '../../shared/card-store.service';
import {UntypedFormBuilder} from '@angular/forms';
import {CardWebConnectorService} from "../../shared/card-web-connector.service";

@Component({
  selector: 'em-editor',
  templateUrl: './editor.component.html',
  styleUrls: ['./editor.component.css']
})
/**
 * Displays the overall page for custom graphs, which consist of the available cards from default carddecks.
 * Split into graph-viewer to see, move and edit the custom graph.
 * And default-decks to show all available cards and being able to move them
 * into the custom graph.
 */
export class EditorComponent implements OnInit {

  userValidation$: Observable<UserValidation>;
  shareOption$: Observable<string>;
  searchForm;
  rightSidenav;
  name;

  constructor(
    private cs: CardStoreService,
    private formBuilder: UntypedFormBuilder,
    private cwcs: CardWebConnectorService
  ) {
    this.shareOption$ = this.cwcs.getDesignShareOption();
    this.resetSearchForm();
  }

  ngOnInit(): void {
    this.cs.getUserLoginListener().subscribe(b => this.userValidation$ = b);
  }

  resetSearchForm() {
     this.searchForm =  this.searchForm = this.formBuilder.group({
      search: '',
    });
  }

}
